import poly from './poly';

const { $ } = poly;

function markActiveLinks() {
  const links = document.querySelectorAll('a');
  const pathName = window.location.pathname;
  const activeLinkParents = document.querySelectorAll('.contains-active');

  let url;
  if (!links) {
    return;
  }

  if (activeLinkParents) {
    $(activeLinkParents).each((linkParent) => {
      $(linkParent).removeClass('contains-active');
    });
  }

  $(links).each((link) => {
    url = link.getAttribute('href');
    if (url !== pathName && url !== pathName + window.location.search) {
      $(link).removeClass('is-active');
    } else {
      $(link).addClass('is-active');
      $(link.parentNode).addClass('contains-active');
    }
  });
}

export default markActiveLinks;
